import { t } from 'i18next'
import React, { FC, useEffect } from 'react'

import { Title } from '@Components/CMS/Title'
import { Modal, ModalProps } from '@Components/Modal'
import { ShippingInfo } from '@Components/Shipping/ShippingInfo'
import { ShippingPolicy } from '@Components/Shipping/ShippingInfoModal/Policy'
import { ShippingToCountry } from '@Components/Shipping/ShippingInfoModal/ToCountry'
import { ShippingPricing } from '@Components/Shipping/ShippingPricing'
import { handleEvent } from '@Events/Manager'
import { OtherEvent } from '@Events/Other'
import { Experiment } from '@Globals/SplitTests/Experiment'

interface ShippingInfoModalProps extends ModalProps {
  sourceID: string
}

export const ShippingInfoModal: FC<ShippingInfoModalProps> = (
  {
    button,
    isOpen,
    sourceID,
    ...rest
  }: ShippingInfoModalProps,
) => {
  useEffect(() => {
    if (!isOpen) {
      return
    }

    handleEvent(new OtherEvent({
      attributes: {
        source_id: sourceID,
      },
      eventName: 'delivery_details_overlay_open',
    }))
  }, [isOpen, sourceID])

  return (
    <Modal {...rest} button="close" isOpen={isOpen} maxWidth="680px">
      <Experiment
        A={<ShippingInfo load={isOpen || false} />}
        B={(
          <>
            <Title title={t('header:SHIPPING_OPTIONS')} type="h3" />
            <ShippingToCountry />
            <ShippingPricing showFreeShippingDescription />
            <ShippingPolicy center />
          </>
        )}
        test="visualize_free_shipping_discount_v1"
      />
    </Modal>
  )
}
